import { useEffect } from "react";
import Icon from "@mdi/react";
import { useTitle } from "easy-page-router/react";
import { mdiAccountEdit, mdiAccountTie } from "@mdi/js";
import { useHeaders } from "../../ssrh/client";

import { useUser } from "../User";
import { Header, Separator } from "../components";
import Footer from "../components/Footer";

const JILEMNICKO_SO_URL = typeof window !== "undefined" && window.location.hostname === "localhost"
    ? "http://localhost:1234"
    : "https://jilemnicko-so.cz";

export default function Mayors() {
    const { user, isAdmin, isMayor } = useUser();

    useTitle("Starosta | TSO Krkonoše");
    useHeaders({
        title: "Starosta | Administrace | TSO Krkonoše",
        description: "Admnistrace pro technický svazek obcí Krkonoše",
        image: (typeof window !== "undefined" ? window.location.origin : "") + "/logo.png",
        canonical: (typeof window !== "undefined" ? window.location.origin + window.location.pathname : ""),
    });

    useEffect(() => {
        if (user === null) {
            const redirectUrl = encodeURIComponent(window.location.origin + "/starosta");
            window.location.href = `${JILEMNICKO_SO_URL}/starosta?redirect=${redirectUrl}`;
        }
    }, [user]);

    return (
        <>
            <main>
                <Header
                    background="stars"
                    title={user === null ? "Přihlášení" : isAdmin ? "Administrace" : "Starosta"}
                />
                <div className="content">
                    <section>
                        <div className="page">
                            {user === null && (
                                <div style={{ textAlign: "center", padding: "80px 0" }}>
                                    <h1>Přihlášení</h1>
                                    <Separator />
                                    <p className="alert">Probíhá přesměrování na přihlašovací portál...</p>
                                </div>
                            )}

                            {user && (
                                <>
                                    <div className="user main">
                                        <Icon path={isAdmin ? mdiAccountEdit : mdiAccountTie} size={5} />
                                        <h2>{user.name}</h2>
                                        <p>{user.mail}</p>
                                        <p>
                                            {isAdmin && <b>Administrátor webu</b>}
                                            {isAdmin && isMayor && " a "}
                                            {isMayor && <b>Starosta</b>}
                                        </p>
                                    </div>

                                    {!isAdmin && !isMayor && (
                                        <p className="alert">Nemáš žádná práva 🙁</p>
                                    )}

                                    {isMayor && <>
                                        <h2>Starosta</h2>
                                        <p style={{ marginTop: "16px", fontSize: "16px" }}>
                                            Pro přístup k rezervačním systémům navštivte webovou stránku:{" "}
                                            <a href="https://jilemnicko-so.cz/starosta" target="_blank" rel="noreferrer">
                                                jilemnicko-so.cz/starosta
                                            </a>.
                                        </p>
                                        <div style={{ height: "100px" }} />
                                    </>}

                                    {isAdmin && (
                                        <div style={{ textAlign: "center", padding: "40px 0" }}>
                                            <h2>Správa uživatelů</h2>
                                            <p style={{ marginBottom: "16px", marginTop: "16px" }}>
                                                Správa uživatelů (starostů i administrátorů) probíhá centrálně na portálu Jilemnicko - společenství obcí.
                                            </p>
                                            <a
                                                href={`${JILEMNICKO_SO_URL}/starosta`}
                                                style={{
                                                    display: "inline-block",
                                                    fontSize: "16px",
                                                    fontWeight: "600",
                                                    textAlign: "center",
                                                    padding: "10px 24px",
                                                    color: "#ffffff",
                                                    backgroundColor: "#009345",
                                                    lineHeight: "30px",
                                                    cursor: "pointer",
                                                    transition: "250ms ease-in-out",
                                                    border: "none",
                                                    textDecoration: "none",
                                                    marginTop: "16px"
                                                }}
                                                onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#1d1d1d")}
                                                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#009345")}
                                            >
                                                Přejít do administrace uživatelů
                                            </a>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </section>
                </div>
            </main>
            <Footer />
        </>
    );
}
